module.exports = __webpack_public_path__ + "media/TransitionXtractive-voiture.962cc374.mp4";